import React from "react";
import { STATUS_LABEL } from "../lib/format";
import { useI18n } from "../i18n/I18nContext";
import { useStatusColors, effectiveStatus } from "../hooks/useStatusColors";

function hexToRgba(hex, a) {
  const h = (hex || "#64748B").replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const FALLBACK_LABELS = {
  atrasada: "Atrasada",
  dia_concluido: "Dia concluído",
  horario_invalido: "Horário inválido",
  ...STATUS_LABEL,
};

export function StatusBadge({ status, job, testId }) {
  const { map } = useStatusColors();
  const { t } = useI18n();
  const effective = job ? effectiveStatus(job) : status;
  const cfg = map[effective];
  // Fallback color matrix when the status isn't in the user-customized list yet
  const fallbackColors = {
    horario_invalido: "#F59E0B", // amber
    atrasada: "#EF4444",
    dia_concluido: "#10B981",
  };
  const color = cfg?.color || fallbackColors[effective] || "#64748B";
  const label = cfg?.label || FALLBACK_LABELS[effective] || effective;

  return (
    <span
      data-testid={testId || `status-${effective}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap"
      style={{
        background: hexToRgba(color, 0.12),
        color: color,
        borderColor: hexToRgba(color, 0.3),
      }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: color }}
      />
      {t(label)}
    </span>
  );
}
